// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slick-slider{width:100%;padding-bottom:30px}.slick-dots{position:absolute;bottom:0;left:0;right:0;display:flex;justify-content:center;align-items:center}.slick-dots ul{margin:0}.slick-dots li{width:10px;height:10px;border-radius:50%;margin:0 5px;cursor:pointer}\n", ""]);
// Exports
module.exports = exports;
